import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import type { ITooltipProps } from "@similarweb/ui-components";
import { Tooltip } from "@similarweb/ui-components";

const WhiteTooltip = styled(Tooltip)`
    && {
        background: white;
        color: ${colorsPalettes.carbon[400]};
        border: 1px solid ${colorsPalettes.carbon[100]};
    }
`;

const Trigger = styled.div<{ enabled?: boolean }>`
    cursor: ${({ enabled }) => (enabled ? "help" : undefined)};
    width: fit-content;
`;

type RankTrackerTooltipProps = ITooltipProps & {
    theme?: "default" | "white";
};

const DEFAULT_DELAY = {
    open: 350,
    close: 200,
};

export const RankTrackerTooltip = ({
    theme = "default",
    delay = DEFAULT_DELAY,
    children,
    enabled = true,
    ...rest
}: RankTrackerTooltipProps) => {
    const props = {
        delay,
        enabled,
        ...rest,
    };

    const trigger = <Trigger enabled={enabled}>{children}</Trigger>;

    if (theme === "white") {
        return <WhiteTooltip {...props}>{trigger}</WhiteTooltip>;
    }

    return <Tooltip {...props}>{trigger}</Tooltip>;
};
